<template>
    <el-dialog title="分类列表" :visible.sync="dialogClassification" append-to-body width="30%" top="5vh">
        <div>
            <el-input placeholder="输入关键字进行过滤" v-model="filterText">
            </el-input>
            <el-tree :data="Treedata" node-key="id" @node-expand="handleNodeExpand" @node-collapse="handleNodeCollapse"
                :props="defaultProps" :default-expanded-keys="defaultExpandIds" draggable :highlight-current="highlight"
                :allow-drop="allowDrop" @node-drop="sort" :expand-on-click-node="false" @node-click="handleNodeClick"
                ref="tree" :filter-node-method="filterNode">
                <span class="custom-tree-node" slot-scope="{ node, data }" @mouseover="mouseover(data)"
                    @mouseleave="mouseleave(data)">
                    <span>{{ data.categoryName }}</span>
                    <span>
                        <i class="el-icon-plus" v-show="data.plus" @click.stop="() => append(data)"></i>
                        <i class="el-icon-minus" v-show="data.minus" @click.stop="() => remove(node, data)"></i>
                    </span>
                </span>
            </el-tree>
        </div>
        <div slot="footer">
            <el-button @click="dialogClassification = false">取 消</el-button>
            <el-button type="primary" @click="saveClassification">确 定</el-button>
        </div>
        <!-- 新建/编辑分类 -->
        <el-dialog :title="isEdit ? '编辑层级' : '创建层级'" :visible.sync="sublevelVisible" :append-to-body="true" width="40%">
            <el-form ref="ruleForm" :model="sublevelForm" :rules="sublevelRules" label-width="120px">
                <el-form-item label="名称" prop="categoryName">
                    <el-input v-model.trim="sublevelForm.categoryName" autocomplete="off" placeholder="请输入名称"
                        style="width:60%">
                    </el-input>
                </el-form-item>
                <el-form-item label="父级">
                    <el-input v-model.trim="sublevelForm.parentName" disabled style="width:60%"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="sublevelVisible = false">取 消</el-button>
                <el-button type="primary" @click="sublevelSubmit('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl, ajaxGet } from '../../api/api/api'
export default {
    name: '',
    data() {
        return {
            Treedata: [],
            sublevelRules: {
                categoryName: [
                    {
                        required: true,
                        message: "请填写子级名称",
                        trigger: "blur"
                    }
                ]
            },
            sublevelVisible: false,
            highlight: true,
            sublevelForm: {},
            dialogClassification: false,
            defaultExpandIds: [],
            defaultProps: {
                children: "children",
                label: "categoryName"
            },
            str: {},
            filterText: '',
            isEdit: false,
            companyId: ''
        }
    },
    created() {
        this.str = JSON.parse(localStorage.getItem('role'))
        this.companyId = this.str.company.id
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    methods: {
        sublevelSubmit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (this.isEdit) {
                        const API = Baseurl + 'systemCategory/update'
                        const paramsData = {
                            id: this.sublevelForm.id,
                            parentId: this.sublevelForm.parentId,
                            categoryName: this.sublevelForm.categoryName,
                            companyId: this.companyId
                        }
                        ajaxPost(API, paramsData)
                            .then((res) => {
                                if (res.data.code === 1) {
                                    this.$message({
                                        type: "success",
                                        message: "编辑成功!"
                                    });
                                    this.sublevelVisible = false
                                    this.getTreedata()
                                    this.getShopifyProduct()
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                    } else {
                        const API = Baseurl + 'systemCategory/create'
                        const paramsData = {
                            parentId: this.sublevelForm.id,
                            categoryName: this.sublevelForm.categoryName,
                            companyId: this.companyId
                        }
                        ajaxPost(API, paramsData)
                            .then((res) => {
                                if (res.data.code === 1) {
                                    this.$message({
                                        type: "success",
                                        message: "添加成功!"
                                    });
                                    this.sublevelVisible = false
                                    this.getTreedata()
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                    }
                } else {
                    this.$message.error("请填写必填项");
                    return false;
                }
            })
        },
        allowDrop(draggingNode, dropNode, type) {
            //pid是父节点id
            if (draggingNode.data.parentId === dropNode.data.parentId) {
                return type === "prev" || type === "next";
            } else {
                // 不同级进行处理
                return false;
            }
        },
        sort(_, dropNode) {
            let obj = {
                params: []
            }
            for (let item of dropNode.parent.childNodes) {
                obj.params.push(item.data);
            }
            this.updateOrderMe(obj)
        },
        updateOrderMe(params) {
            const API = Baseurl + 'systemCategory/updateSort'
            ajaxPost(API, params)
                .then((res) => {
                    if (res.data.code === 1) {
                        // this.getTreedata()
                        this.$message.success("修改成功");
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
        },
        // 树节点展开
        handleNodeExpand(data) {
            // 保存当前展开的节点
            let flag = false
            this.defaultExpandIds.some(item => {
                if (item === data.id) { // 判断当前节点是否存在， 存在不做处理
                    flag = true
                    return true
                }
            })
            if (!flag) { // 不存在则存到数组里
                this.defaultExpandIds.push(data.id)
            }
        },
        // 树节点关闭
        handleNodeCollapse(data) {
            // 删除当前关闭的节点
            this.defaultExpandIds.some((item, i) => {
                if (item === data.id) {
                    this.defaultExpandIds.splice(i, 1)
                }
            })
            this.removeChildrenIds(data) // 这里主要针对多级树状结构，当关闭父节点时，递归删除父节点下的所有子节点
        },
        // 删除树子节点
        removeChildrenIds(data) {
            const ts = this
            if (data.children) {
                data.children.forEach(function (item) {
                    const index = ts.defaultExpandIds.indexOf(item.id)
                    if (index > 0) {
                        ts.defaultExpandIds.splice(index, 1)
                    }
                    ts.removeChildrenIds(item)
                })
            }
        },
        handleNodeClick(val, node) {
            this.highlight = true
            let joinName1 = ''
            let joinName2 = ''
            let joinName3 = ''
            if (node.data.categoryName) {
                joinName1 = node.data.categoryName
                if (node.parent.data.categoryName) {
                    joinName2 = node.parent.data.categoryName + '-'
                    if (node.parent.parent.data.categoryName) {
                        joinName3 = node.parent.parent.data.categoryName + '-'
                    } else {
                        joinName3 = ''
                    }
                } else {
                    joinName2 = ''
                }
            } else {
                joinName1 = ''
            }
            const joinName = joinName3 + joinName2 + joinName1
            if (val.menuType == 3) {
                this.select = {
                    id: val.id,
                    name: val.categoryName,
                    joinName: joinName
                }
            } else {
                this.select = ''
            }
            this.getShopifyProduct(val.id)
        },
        mouseover(data) {
            if (data.menuType == 0) {
                this.$set(data, 'plus', true)
                this.$set(data, 'minus', false)
                this.$set(data, 'edit', false)
            } else if (data.menuType == 3) {
                this.$set(data, 'plus', false)
                this.$set(data, 'minus', true)
                this.$set(data, 'edit', true)
            } else if (data.menuType == 1 || data.menuType == 2) {
                this.$set(data, 'plus', true)
                this.$set(data, 'minus', true)
                this.$set(data, 'edit', true)
            }
        },
        mouseleave(data) {
            this.$set(data, 'plus', false)
            this.$set(data, 'minus', false)
            this.$set(data, 'edit', false)
        },
        init() {
            this.dialogClassification = true
            this.getTreedata()
        },
        getTreedata() {
            const API = Baseurl + 'systemCategory/find?companyId=' + this.str.company.id
            ajaxGet(API)
                .then((res) => {
                    if (res.data.code === 1) {
                        // this.Treedata = res.data.data
                        this.$set(this.Treedata, 0, { categoryName: '分类列表', children: [], menuType: 0, id: '0' })
                        res.data.data.forEach(item => {
                            this.$set(item, 'menuType', 1)
                            if (item.children) {
                                item.children.forEach(val => {
                                    this.$set(val, 'menuType', 2)
                                    if (val.children) {
                                        val.children.forEach(key => {
                                            this.$set(key, 'menuType', 3)
                                        })
                                    }
                                })
                            }
                        })
                        this.Treedata[0].children = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
        },
        getShopifyProduct(categoryId = '') {
            if (typeof (categoryId) == 'object') {
                categoryId = ''
            }
            const API = Baseurl + 'systemProduct/page'
            const paramsData = {
                categoryId
            }
            this.loading = true
            ajaxPost(API, paramsData)
                .then((res) => {
                    if (res.data.code === 1) {
                        this.summarylist = res.data.data.records
                        this.summarylist.forEach(val => {
                            const source = val.sourceUrl.split(',')
                            val.productImages = val.productImages.split(',')
                            if (val.productImages.length) val.productImage = val.productImages[0]
                            val.sourceUrl = source.map((item) => ({
                                url: item
                            }))
                        })
                        this.count = res.data.data.total
                    } else {
                        this.$message.error(res.data.message)
                    }
                    this.loading = false
                })
        },
        append(data) {
            this.isEdit = false;
            this.sublevelVisible = true
            if (data) {
                this.sublevelForm = {
                    parentName: data.categoryName,
                    categoryName: "",
                    id: data.id,
                    parentId: data.parentId
                }
            } else {
                this.sublevelForm = {
                    parentName: 0,
                    categoryName: "",
                    id: "",
                    parentId: ""
                }
            }
        },
        remove(_, data) {
            this.$confirm("此操作将永久删除该分类, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    const API = Baseurl + 'systemCategory/delete/' + data.id
                    ajaxGet(API)
                        .then((res) => {
                            if (res.data.code === 1) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!"
                                });
                                this.getTreedata()
                                this.getShopifyProduct()
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        saveClassification() {
            if(this.select) {
                // this.classification = this.select
                this.$emit("childvalue", this.select)
                this.dialogClassification = false
            }else{
                this.$message.warning('请选择第三层级')
            }
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.categoryName.indexOf(value) !== -1;
        }
    }
}
</script>
<style lang="scss" scoped>
/deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: #ccc !important;
}

/deep/ .el-tree-node__content:hover {
    background: #eee !important;
}

/deep/ .el-dialog__body {
    max-height: 500px;
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;

    .el-icon-minus {
        margin: 0 8px;
    }
}
</style>